import { Observable } from "rxjs";
import { GetOptions } from "./options/get.options";

export class HttpClientService {
  static get<TResponse>(
    url: string,
    getOptions?: GetOptions,
  ): Observable<TResponse> {
    const options = {} as RequestInit;
    options.method = "GET";

    if (getOptions?.headers) options.headers = getOptions.headers;

    return new Observable((subscriber) => {
      fetch(url, options)
        .then((response) => {
          if (!response.ok) {
            const error = new Error("HTTP status code: " + response.status);
            return subscriber.error(error);
          }

          if (response.redirected) return response.url;
          if (response.type === "opaqueredirect") return response.url;

          if (getOptions?.response?.responseType === "text")
            return response.text();
          return response.json();
        })
        .then((data) => subscriber.next(data))
        .catch((error) => subscriber.error(error));
    });
  }

  static post<TResponse, TDataType extends BodyInit>(
    url: string,
    data: TDataType,
    header?: Headers,
  ): Observable<TResponse> {
    const options = {} as RequestInit;
    options.method = "POST";
    options.body = data;
    if (header) options.headers = header;

    return new Observable((subscriber) => {
      fetch(url, options)
        .then((response) => {
          if (response.redirected) return response.url;
          if (response.type === "opaqueredirect") return response.url;

          return response.json();
        })
        .then((data) => subscriber.next(data))
        .catch((error) => subscriber.error(error));
    });
  }

  static delete<TResponse>(url: string): Observable<TResponse> {
    const options = {} as RequestInit;
    options.method = "DELETE";

    return new Observable((subscriber) => {
      fetch(url, options)
        .then((response) => {
          if (response.redirected) return response.url;
          if (response.type === "opaqueredirect") return response.url;

          return response.json();
        })
        .then((data) => subscriber.next(data))
        .catch((error) => subscriber.error(error));
    });
  }
}
